import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-slate-800 text-white pt-20 pb-16 px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-12">
          <div className="flex flex-col gap-4">
            <div className="h-20 w-auto flex items-center">
              <img
                src="https://static.readdy.ai/image/d4274df8353789ddb57f96b2fb2e8c2d/41e04a64e64671a6d110ea96f1687540.png"
                alt="IIJ Logo"
                className="h-full w-auto object-contain"
              />
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-1">{t('footer.companyName')}</h3>
              <p className="text-sm text-gray-400">{t('footer.partnership')}</p>
            </div>
          </div>

          <div className="text-left md:text-right">
            <p className="text-gray-300 mb-2">{t('footer.address')}</p>
            <p className="text-gray-300 mb-2">
              Email: <a href={`mailto:${t('footer.email')}`} className="hover:text-white transition-colors cursor-pointer">{t('footer.email')}</a>
            </p>
            <p className="text-gray-300">
              Website: <a href={t('footer.website')} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">{t('footer.website')}</a>
            </p>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} PT. IIJ Global Solutions Indonesia. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
